export const ASSETS_STATUSES_LOAD = 'ASSETS_STATUSES_LOAD'
export const ASSETS_STATUSES_LOAD_PENDING = 'ASSETS_STATUSES_LOAD_PENDING'
export const ASSETS_STATUSES_LOAD_FULFILLED = 'ASSETS_STATUSES_LOAD_FULFILLED'
export const ASSETS_STATUSES_LOAD_REJECTED = 'ASSETS_STATUSES_LOAD_REJECTED'

export const SET_ASSETS_STATUSES_FILTERS = 'SET_ASSETS_STATUSES_FILTERS'
